import React from 'react';

export default function Navbar({ navItems, activeSection, menuOpen, setMenuOpen, scrolled, onNavClick }) {
  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <h1 className="nav-logo">MY PORTFOLIO</h1>

        <button
          className={`nav-toggle ${menuOpen ? 'active' : ''}`}
          onClick={() => setMenuOpen((open) => !open)}
          aria-label="Toggle navigation"
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        <ul className={`nav-menu ${menuOpen ? 'open' : ''}`}>
          {navItems.map((item) => (
            <li className="nav-item" key={item.id}>
              <button
                className={activeSection === item.id ? 'active' : ''}
                onClick={() => onNavClick(item.id)}
              >
                {item.icon && <span className="nav-icon">{item.icon}</span>}
                <span>{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
